import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../api/axios';
import { AdminPageHeader, AdminStatusBadge, AdminTableCard } from './AdminUi';
import './admin.css';

export default function AdminHealthDocuments() {
  const [data, setData] = useState({ total: 0, results: [] });
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get('admin/health-documents/', { params: { limit: 100 } })
      .then((r) => setData(r.data))
      .catch((e) => toast.error(e.response?.data?.error || 'Failed'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this document?')) return;
    await api.delete(`admin/health-documents/${id}/`);
    toast.success('Deleted');
    load();
  };

  return (
    <div>
      <AdminPageHeader title="Health Documents" subtitle={`${data.total} documents`} />

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border text-primary" /></div>
      ) : (
        <AdminTableCard>
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th><th>Title</th><th>Type</th><th>User</th><th>Source</th><th>File</th><th></th>
              </tr>
            </thead>
            <tbody>
              {data.results.map((d) => (
                <tr key={d.id}>
                  <td>{d.id}</td>
                  <td className="fw-semibold">{d.title}</td>
                  <td><AdminStatusBadge status={d.document_type} /></td>
                  <td className="small">{d.user_email}</td>
                  <td>{d.source}</td>
                  <td>
                    {d.file_url ? (
                      <a href={d.file_url} target="_blank" rel="noreferrer">Open</a>
                    ) : '—'}
                  </td>
                  <td>
                    <button className="btn btn-sm btn-outline-danger rounded-pill px-3" onClick={() => remove(d.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </AdminTableCard>
      )}
    </div>
  );
}
